import React, { useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { HOME_MENU } from "../constants/homeMenu";

function RailLink({ item, onClick }) {
  const location = useLocation();
  const ref = useRef(null);
  const active =
    location.pathname === item.link ||
    location.pathname.startsWith(`${item.link}/`);
  const Icon = item.icon;

  useEffect(() => {
    if (active) {
      ref.current?.scrollIntoView({ block: "nearest" });
    }
  }, [active]);

  return (
    <NavLink
      ref={ref}
      to={item.link}
      title={item.title}
      onClick={onClick}
      className={`rail-link flex shrink-0 flex-col items-center gap-1 px-1.5 py-1.5 ${
        active ? "text-white" : "text-white/75 hover:text-white"
      }`}
    >
      <span
        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${
          active ? "bg-white text-[#6E63F6]" : ""
        }`}
      >
        <Icon className="h-4 w-4" />
      </span>
      <span className="line-clamp-2 w-full text-center text-[10px] font-medium leading-[1.15]">
        {item.title}
      </span>
    </NavLink>
  );
}

function RailBody({ onNavigate }) {
  return (
    <div className="flex h-full min-h-0 w-[5.6rem] flex-col overflow-hidden rounded-r-[2.25rem] bg-[#6E63F6] py-3 shadow-[8px_8px_28px_rgba(110,99,246,0.22)]">
      <NavLink
        to="/"
        onClick={onNavigate}
        title="Beranda"
        className="rail-link mb-1 flex h-10 shrink-0 items-center justify-center"
      >
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-sm font-bold text-[#6E63F6]">
          S
        </span>
      </NavLink>
      <nav className="flex min-h-0 flex-1 flex-col overflow-y-auto overscroll-y-contain px-0.5 pb-1 [scrollbar-width:thin]">
        {HOME_MENU.filter((item) => item.sidebar !== false).map((item) => (
          <RailLink key={item.link} item={item} onClick={onNavigate} />
        ))}
      </nav>
    </div>
  );
}

function Sidebar({ sidebarOpen, setSidebarOpen }) {
  return (
    <>
      {sidebarOpen && (
        <aside className="fixed inset-y-3 left-0 z-40 hidden tablet:flex">
          <RailBody />
        </aside>
      )}

      {sidebarOpen && (
        <div className="fixed inset-0 z-50 tablet:hidden">
          <div
            className="fixed inset-0 bg-slate-900/25"
            onClick={() => setSidebarOpen(false)}
          />
          <div className="fixed inset-y-3 left-0 z-50 flex">
            <RailBody onNavigate={() => setSidebarOpen(false)} />
          </div>
        </div>
      )}
    </>
  );
}

export default Sidebar;
